module.exports = __webpack_public_path__ + "img/bj.5b5bd166.png";